import { styled } from '@mui/material/styles'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { RegionModel } from 'shared/api'

import LanguageNotAvailableMessage from './LanguageNotAvailableMessage'
import LanguageSelection, { LanguageChangePath } from './LanguageSelection'
import { SimpleAlertDialog } from './base/AlertDialog'
import H1 from './base/H1'

const ChooseLanguage = styled('p')`
  margin: 25px 0;
  text-align: center;
`

type LanguageFailureProps = {
  regionModel: RegionModel
  languageCode: string
  languageChangePaths: LanguageChangePath[]
}

const LanguageFailure = ({ regionModel, languageCode, languageChangePaths }: LanguageFailureProps): ReactElement => {
  const [alertDialogTitle, setAlertDialogTitle] = useState<string | null>(null)
  const { t } = useTranslation()

  const closeAlertDialog = () => setAlertDialogTitle(null)

  return (
    <>
      <H1>{regionModel.name}</H1>
      <ChooseLanguage>{t($ => $.languages.error.notFound.title)}</ChooseLanguage>
      <LanguageSelection
        openAlertDialog={setAlertDialogTitle}
        languageCode={languageCode}
        languageChangePaths={languageChangePaths}
        asList
      />
      {alertDialogTitle ? (
        <SimpleAlertDialog
          title={alertDialogTitle}
          body={<LanguageNotAvailableMessage close={closeAlertDialog} />}
          close={closeAlertDialog}
        />
      ) : null}
    </>
  )
}

export default LanguageFailure
